import Storefront from 'utils/storefront';
import { variantGet } from 'utils/storefront/queries';

const storefront = Storefront.getInstance();

async function checkVariantInStock(
  variantId, variantCartQuantity = 0
) {
  const { lowStockWarningThreshold, safetyStockQuantity } = window.TMW;

  if (lowStockWarningThreshold && safetyStockQuantity) {
    const variant = await getVariantDataById(variantId);
    const { quantityAvailable } = variant;
    const ignoreSafetyStock = variant?.product?.ignoreSafetyStock?.value === 'true';

    if (ignoreSafetyStock) return variant?.availableForSale;

    const variantAvailable = quantityAvailable - variantCartQuantity
      > safetyStockQuantity;
    const lowStock = quantityAvailable - variantCartQuantity
      <= lowStockWarningThreshold

    if (!variant) {
      return Promise.reject(
        new Error(`variant ${variantId} is not available`)
      );
    }

    if (!variantAvailable) {
      document.dispatchEvent(new CustomEvent('variant:out-of-stock', {
        detail: {
          payload: {
            id: variantId,
          },
        },
      }));

      return false;
    }

    if (lowStock && variantAvailable) {
      document.dispatchEvent(new CustomEvent('variant:low-stock', {
        detail: {
          payload: {
            id: variantId,
          },
        },
      }));

      return true;
    }
  }

  return true;
}

async function getVariantDataById(id) {
  const variantId = id.toString().includes("gid") ?
    id : `gid://shopify/ProductVariant/${id}`;

  const variant = await storefront.request({
    query: variantGet,
    variables: {
      id: variantId
    },
  });

  return variant.data.node;
}

export {
  getVariantDataById,
  checkVariantInStock,
}
